export default __webpack_public_path__ + "static/media/EventFairy.8631df15.jpg";